import { String } from 'aws-sdk/clients/cloudhsm'
import React, { useEffect, useState } from 'react'
import './styles.scss'
import Scrollchor from 'react-scrollchor'
import { useWindowSize } from './useWindowSize'

export const ChapterNavigation = ({
  content,
  current,
  setCurrent
}: {
  content: { name: JSX.Element | String; id: string }[]
  current?: string
  setCurrent?: React.Dispatch<React.SetStateAction<string>>
}) => {
  const [hovered, setHovered] = useState<number | undefined>(undefined)
  const [open, setopen] = useState<boolean>(false)
  const { width, isMobile } = useWindowSize()

  return (
    <div
      className={
        'ChapterNavigation ' +
        (isMobile ? 'mob ' : 'desk ') +
        (open ? 'open' : 'closed')
      }
    >
      <div className='wrapper'>
        <div className='content'>
          {content.map((m, i) => {
            return (
              <Scrollchor
                to={m.id}
                key={i}
                className={'scroll ' + (hovered === i ? 'hov' : '')}
              >
                <div
                  className={'entry ' + (current === m.id ? 'current' : '')}
                  onClick={() => {
                    if (setCurrent) setCurrent(m.id)
                    setopen(false)
                  }}
                  onMouseEnter={!isMobile ? () => setHovered(i) : undefined}
                  onMouseLeave={
                    !isMobile ? () => setHovered(undefined) : undefined
                  }
                >
                  {hovered === i || isMobile ? (
                    <>
                      {m.name} <img src={require('./' + m.id + '.png')} />
                    </>
                  ) : (
                    <img src={require('./' + m.id + '.png')} />
                  )}
                </div>
              </Scrollchor>
            )
          })}
        </div>
        <div className='switch' onClick={() => setopen(!open)}>
          <img src={require('./icn_close.svg')} className='open' />
          <img src={require('./icn_menu.svg')} className='close' />
        </div>
      </div>
    </div>
  )
}
